var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 10.683,
    viewBox: "0 0 5 10.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9ea0a5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M481.907,273.839l.761.742a.246.246,0,0,1-.2.418h-8.027a.445.445,0,0,0-.446.5v0a.448.448,0,0,0,.446.5h8.019a.252.252,0,0,1,.194.428l-.757.73a.473.473,0,0,0,.022.705v0a.563.563,0,0,0,.753-.022l1.712-1.671a.951.951,0,0,0,0-1.379l-1.7-1.641a.562.562,0,0,0-.749-.021l-.005.005a.471.471,0,0,0-.027.7",
    transform: "translate(-273 484.683) rotate(-90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.2519bcd1dd47c8e39a8fffd46f52162b.svg";
export { ForwardRef as ReactComponent };